import React from "react";
import RegistrationForm from "./RegistrationForm";
import RegisterCourse from "./RegisterCourse";
import Footer from "../../../Components/Footer/Footer";
import { backend_data } from "../ServicesDisplayPage/servicesData";

const Register_backend = () => {
  const page_data = {
    data: backend_data,
    title: "Backend Development",
    description: "Master backend with Node.js, Express & Databases",
    amount: 4000,
  };

  return (
    <>
      {/* Registration Form instead of Hero */}
      <RegistrationForm page_data={page_data} />

      {/* Service Body (course details/steps) */}
      <RegisterCourse service_steps={page_data} />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Register_backend;
